import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-page-not-found',
  imports: [TranslateModule, NgOptimizedImage],
  templateUrl: './page-not-found.component.html',
  standalone: true,
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
  constructor(private $router: Router) {}

  goBack(): void {
    this.$router.navigate(['/']).then();
  }
}
